





























import Vue from 'vue'
import CsvImportStepOne from '@/components/CsvImportStepOne.vue'
import CsvImportStepTwo from '@/components/CsvImportStepTwo.vue'
import CsvImportStepThree from '@/components/CsvImportStepThree.vue'
import CsvImportStepFour from '@/components/CsvImportStepFour.vue'
import ProgressSpinner from '@/components/ProgressSpinner.vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    components: {
        CsvImportStepOne,
        CsvImportStepTwo,
        CsvImportStepThree,
        CsvImportStepFour,
        ProgressSpinner
    },
    data() {
        return {
            toolbar: {
                title: 'Import and Export Contacts',
                subtitle: null,
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0
                    }
                ],
                right: []
            },
            step: 1
        }
    },
    mounted() {
        //  Grab the new group query from our path
        const newGroup = this.$route.query.new_group

        //  IF it exists, then navigate to step 2
        if (newGroup) this.step = 2

        //  Regardless, make sure we get our person properties and reset CSV
        this.$store.dispatch('personPropertiesGet')
        this.$store.commit('csvReset')
    },
    computed: {
        ...mapGetters(['csvFileName', 'csvImportProgress'])
    },
    methods: {
        async importExecute(): Promise<void> {
            //  Start csv progress immediately
            this.$store.commit('csvImportProgressSet', {
                percent: 0,
                message: 'Beginning CSV Import'
            })

            //  Go back to step 1
            this.step = 1

            //  If user came from broadcasts, pop message 
            if (this.$route.query.goto == '/broadcasts/create') this.popRoutingDialog()

            //  Set the csv mapping first, then we send the file
            const map = await this.$store.dispatch('csvMap')

            //  If the request failed, do nothing
            if (!map) return

            //  Else, upload the file to the API
            const response = await this.$store.dispatch('csvImport')

            //  If the request failed, do nothing
            if (!response) return

            //  Reset import group
            this.$store.commit('importGroupSet', null)

            //  Fetch the person count form the api (to determine is this is the first import)
            const count = await this.$store.dispatch('personsCount')

            //  If the request failed, do nothing
            if (!count) return
        },
        popRoutingDialog(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'CSV Importing',
                text: `Your contacts are being uploaded, You'll be notified when it's complete and will also be routed to broadcasts if you stay on this page.`,
                icon: 'mdi-help-circle',
                color: 'primary'
            })
        }
    },
    watch: {
        csvFileName(name: string): void {
            this.toolbar.subtitle = name
        },
        step(value: number): void {
            //  If we get to step 2, make sure we reset step 2
            if (value === 2) this.$refs.csvStepTwo.resetInput()
        }
    }
})
